import { logger } from '../../util/logger';
import { renderModel } from '../../util/renderModel';
import { HttpClientFactory } from '../httpClient';

const { clientTopology } = renderModel.get();

export type SearchArticlesItem = {
  id: string;
  title: string;
  url: string;
};

export const searchArticles = (
  query: string,
  limit: number,
  offset: number,
  httpClient: HttpClientFactory,
  excludedCategories?: string[],
): Promise<SearchArticlesItem[]> => {
  const filter = excludedCategories ? { filter: { excludedCategories } } : {};
  return httpClient
    .getInstance()
    .post(clientTopology.articlesSearchURL, {
      query,
      limit,
      offset,
      ...filter,
    })
    .then((r) =>
      r.data.articles.map((article) => ({
        ...article,
        id: article.article_id,
      })),
    )
    .catch((error) => {
      logger.log({
        message: `fail to fetch search articles by query: ${query}`,
        error,
      });
      console.error(error);
    });
};
